import styled from "styled-components";

import { Input } from "ds/Input";

export const SearchInputRoot = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  position: relative;

  svg:first-child {
    left: 8px;
    position: absolute;
  }

  svg:last-child {
    right: 8px;
    position: absolute;
    cursor: pointer;
  }
`;

export const SearchInput = styled(Input)`
  width: 100%;
  height: 32px;
  background-color: var(--ebony);
  color: var(--granite);
  border-color: transparent;
  font-size: 14px;
  padding-left: 36px;

  &:focus {
    color: var(--snow);
    background-color: var(--ebony);
  }

  &::placeholder {
    font-size: 14px;
  }
`;

SearchInput.defaultProps = {
  isValid: true
};
